import { Grid } from "@mui/material";
import { Custom } from "components";
import { useApp } from "context";
import { useForm } from "hooks";
import { IAppointment } from "interfaces";
import { Constants, Enums, Helpers } from "utils";

type Props = {
  onSubmit: (
    step: number,
    email: string,
    patientId: number,
    appointments: IAppointment[]
  ) => void;
};

export const QioskEmail = (props: Props) => {
  const { t, theme, service } = useApp();

  const initialState = { email: "" };

  const { onChange, onSubmit, values } = useForm(submitCallback, initialState);

  async function submitCallback() {
    const { email }: any = values;

    if (email === Constants.QIOSK_PASSCODE) {
      props.onSubmit &&
        props.onSubmit(Enums.EnumCheckInStep.Email, email, -1, []);
      return;
    }

    if (Helpers.hasValue(email)) {
      const response = await service.patient.exist(email);
      if (!response) {
        props.onSubmit &&
          props.onSubmit(Enums.EnumCheckInStep.WalkInNotAllowed, email, -1, []);
      } else if (response.appointments && response.appointments.length > 0) {
        // the user has appointments => go to appoitnments selection
        props.onSubmit &&
          props.onSubmit(
            Enums.EnumCheckInStep.Appointment,
            email,
            response.patientId,
            response.appointments
          );
      } else if (response.patientId) {
        // the user has an account => go to home and create an appointment
        props.onSubmit &&
          props.onSubmit(
            Enums.EnumCheckInStep.MakeAppointment,
            email,
            response.patientId,
            []
          );
      } else {
        // the user has no account => go to register
        props.onSubmit &&
          props.onSubmit(Enums.EnumCheckInStep.Register, email, -1, []);
      }
    }
  }

  return (
    <form onSubmit={onSubmit} className="qh-form">
      <Grid container spacing={theme.margin.sm}>
        <Grid item xs={12}>
          <Custom.TextField
            name="email"
            type="email"
            focused={true}
            required={true}
            onChange={onChange}
            placeholder={t.placeholder.email}
          />
        </Grid>
        <Grid item xs={12}>
          <div className="qh-control">
            <Custom.Button
              sx={{ width: "100%", height: 58, fontSize: theme.font.lg }}
              submit
            >
              {t.action.submit}
            </Custom.Button>
          </div>
        </Grid>
      </Grid>
    </form>
  );
};
